module.exports = __webpack_public_path__ + "static/media/image-card-4.42363bc8.png";